import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-newsletters',
  templateUrl: './newsletters.component.html',
  styleUrls: ['./newsletters.component.scss']
})
export class NewslettersComponent implements OnInit {

  constructor(public api:ApiService,private sanitizer: DomSanitizer) { }

  news:any;

  ngOnInit(): void {
    this.api.post("pro=getNewsletters",this.api.user).then((res:any)=>{
      this.news = res;
      if(this.news[0])
        this.select(this.news[0]);
    });
  }

  select(n){
    this.api.getHtml("https://admin.blackrockgames.fr/api/newsletter/"+n.id_html+".html").then((res:any)=>{
      res = res.replace('{{link}}','');
        let frame = document.getElementById('iframe');
        let doc = frame['contentWindow'].document;
        doc.open();
        doc.write(res);
        doc.close();
        frame.onload = function(){
          let trs = doc.getElementsByTagName("tr");
          trs[1].style.display = 'none';
          frame.style.display = 'block';          
          setTimeout(()=>{    
            frame.style.height = doc.body.scrollHeight  +'px';
          },100);
        }
    });
    /*this.url = this.sanitizer.bypassSecurityTrustResourceUrl('http://admin.blackrockgames.fr/api/newsletter/'+n.id_html+'.html')
    setTimeout(()=>{
      let frame = document.getElementById("iframe");
      frame.onload = function(){
        console.log(frame['contentWindow'].document);
        //frame.style.height = frame['contentWindow'].document.body.scrollHeight + 'px'
      }
    },200);*/
    //frame.style.height = frame.contentWindow.document.body.scrollHeight + 'px';
  }

}
